var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6937 67.3874C52.3022 67.3874 67.3874 52.3022 67.3874 33.6937C67.3874 15.0852 52.3022 0 33.6937 0C15.0852 0 0 15.0852 0 33.6937C0 52.3022 15.0852 67.3874 33.6937 67.3874Z",
    fill: "url(#paint0_linear_2481_362)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6938 60.4505C48.4711 60.4505 60.4505 48.4711 60.4505 33.6938C60.4505 18.9164 48.4711 6.93701 33.6938 6.93701C18.9164 6.93701 6.93701 18.9164 6.93701 33.6938C6.93701 48.4711 18.9164 60.4505 33.6938 60.4505Z",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 0.432432
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M33.6936 43.604C39.1667 43.604 43.6035 39.1672 43.6035 33.6941C43.6035 28.221 39.1667 23.7842 33.6936 23.7842C28.2205 23.7842 23.7837 28.221 23.7837 33.6941C23.7837 39.1672 28.2205 43.604 33.6936 43.604Z",
    stroke: "white",
    strokeWidth: 1.8018
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6938 27.2524V34.6849L39.1443 38.1533",
    stroke: "white",
    strokeWidth: 1.8018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2481_362",
    x1: 0,
    y1: 0,
    x2: 67.3874,
    y2: 67.3874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB84D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B24E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.cfe9089e4e5f419a609c3a0b9621d020.svg";
export { ForwardRef as ReactComponent };